import {Rule} from '../../models/svg-rule/rule.model';
import {IRuleSystem} from '../../models/svg-rule/rule-system.model';
import {Color} from '../../enums/color';
import {TcddTrainTabUtil, ValueIndex} from '../../utils/tcdd-train-tab-util';
import {TcddMainSystem} from '../../enums/tcdd-main-system.enum';
import {TcddSubSystem} from '../../enums/tcdd-sub-system.enum';
import {TcddSubSystemType} from '../../enums/tcdd-sub-system-type.enum';
import {AirConditionSystemKeys} from '../../constants/tcdd-system-keys/air-condition-system-keys';
import {AIR_CONDITION_SYSTEM} from '../../constants/tcdd-system-contants/air-condition-system.constant';
import {TCDD_UNIT} from '../../constants/tcdd-unit-constant';
import {createColorRule, createTextRule} from '../../utils/tcdd-rule-util';

function getIndex(key: string): ValueIndex {
  return TcddTrainTabUtil.getValueIndex(
    TcddMainSystem.DIAGNOSTIC_SYSTEM,
    TcddSubSystem.AIR_CONDITION_SYSTEM,
    TcddSubSystemType.SUB,
    key
  );
}

export class AirConditionSystemRules implements IRuleSystem {
  public getRules(): Rule[] {
    return [
      createColorRule(TCDD_UNIT.DRIVER_HVAC, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const driverHvacCommunicationError: ValueIndex = getIndex(AirConditionSystemKeys.driverHvacCommunicationError); // === 1 will be pink
        const driverHvacMajorError: ValueIndex = getIndex(AirConditionSystemKeys.driverHvacMajorError); // === 1 will be red
        const driverHvacMinorError: ValueIndex = getIndex(AirConditionSystemKeys.driverHvacMinorError); // === 1 will be orange
        const driverHvacClosed: ValueIndex = getIndex(AirConditionSystemKeys.driverHvacClosed); // === 1 will be gray

        if (Number(wagonData[driverHvacCommunicationError.groupIndex]?.[driverHvacCommunicationError.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.DRIVER_HVAC_COMMUNICATION_ERROR) { // Pink state
          setColor(Color.Pink);
          return true;
        }

        if (Number(wagonData[driverHvacMajorError.groupIndex]?.[driverHvacMajorError.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.DRIVER_HVAC_MAJOR_ERROR) { // Red state
          setColor(Color.Red);
          return true;
        }

        if (Number(wagonData[driverHvacMinorError.groupIndex]?.[driverHvacMinorError.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.DRIVER_HVAC_MINOR_ERROR) { // Orange state
          setColor(Color.Orange);
          return true;
        }

        if (Number(wagonData[driverHvacClosed.groupIndex]?.[driverHvacClosed.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.DRIVER_HVAC_CLOSED) { // Gray state
          setColor(Color.Gray);
          return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.HVAC_1, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const hvac1CommunicationError: ValueIndex = getIndex(AirConditionSystemKeys.hvac1CommunicationError); // === 1 will be pink
        const hvac1MajorError: ValueIndex = getIndex(AirConditionSystemKeys.hvac1MajorError); // === 1 will be red
        const hvac1MinorError: ValueIndex = getIndex(AirConditionSystemKeys.hvac1MinorError); // === 1 will be orange
        const hvac1Closed: ValueIndex = getIndex(AirConditionSystemKeys.hvac1Closed); // === 1 will be gray

        if (Number(wagonData[hvac1CommunicationError.groupIndex]?.[hvac1CommunicationError.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.HVAC_1_COMMUNICATION_ERROR) { // Pink state
          setColor(Color.Pink);
          return true;
        }

        if (Number(wagonData[hvac1MajorError.groupIndex]?.[hvac1MajorError.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.HVAC_1_MAJOR_ERROR) { // Red state
          setColor(Color.Red);
          return true;
        }

        if (Number(wagonData[hvac1MinorError.groupIndex]?.[hvac1MinorError.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.HVAC_1_MINOR_ERROR) { // Orange state
          setColor(Color.Orange);
          return true;
        }

        if (Number(wagonData[hvac1Closed.groupIndex]?.[hvac1Closed.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.HVAC_1_CLOSED) { // Gray state
          setColor(Color.Gray);
          return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.HVAC_2, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const hvac2CommunicationError: ValueIndex = getIndex(AirConditionSystemKeys.hvac2CommunicationError); // === 1 will be pink
        const hvac2MajorError: ValueIndex = getIndex(AirConditionSystemKeys.hvac2MajorError); // === 1 will be red
        const hvac2MinorError: ValueIndex = getIndex(AirConditionSystemKeys.hvac2MinorError); // === 1 will be orange
        const hvac2Closed: ValueIndex = getIndex(AirConditionSystemKeys.hvac2Closed); // === 1 will be gray

        if (Number(wagonData[hvac2CommunicationError.groupIndex]?.[hvac2CommunicationError.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.HVAC_2_COMMUNICATION_ERROR) { // Pink state
          setColor(Color.Pink);
          return true;
        }

        if (Number(wagonData[hvac2MajorError.groupIndex]?.[hvac2MajorError.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.HVAC_2_MAJOR_ERROR) { // Red state
          setColor(Color.Red);
          return true;
        }

        if (Number(wagonData[hvac2MinorError.groupIndex]?.[hvac2MinorError.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.HVAC_2_MINOR_ERROR) { // Orange state
          setColor(Color.Orange);
          return true;
        }

        if (Number(wagonData[hvac2Closed.groupIndex]?.[hvac2Closed.infoIndex]) === AIR_CONDITION_SYSTEM.STATUS.HVAC_2_CLOSED) { // Gray state
          setColor(Color.Gray);
          return true;
        }

        return false;
      }),
      createTextRule(
        TCDD_UNIT.TEXT_DRIVER_HVAC_TRAIN,
        (wagonIndex: number, data: any[], setColor, setText, setPosition, setTextAnchor) => {
          const textValue = data?.[TcddSubSystem.TEXT_SYSTEM]?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.[wagonIndex]?.[AirConditionSystemKeys.driverHvac] ?? '-';
          setText(`${textValue} °C`);
          setColor(Color.White);

          const size = data?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.length ?? 0;
          const isLastWagon = wagonIndex === size - 1;

          setPosition(isLastWagon ? 'right' : 'left');
          setTextAnchor(isLastWagon ? 'start' : 'end');

          return true;
        },
        {
          fontSize: '16',
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: '700',
          offsetX: 5,
          offsetY: 0
        }
      ),
      createTextRule(
        TCDD_UNIT.TEXT_HVAC_1_TRAIN,
        (wagonIndex: number, data: any[], setColor, setText, setPosition, setTextAnchor) => {
          const textValue = data?.[TcddSubSystem.TEXT_SYSTEM]?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.[wagonIndex]?.[AirConditionSystemKeys.hvac1] ?? '-';
          setText(`${textValue} °C`);
          setColor(Color.White);

          const size = data?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.length ?? 0;
          const isLastWagon = wagonIndex === size - 1;

          setPosition(isLastWagon ? 'right' : 'left');
          setTextAnchor(isLastWagon ? 'start' : 'end');

          return true;
        },
        {
          fontSize: '16',
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: '700',
          offsetX: 5,
          offsetY: 0
        }
      ),
      createTextRule(
        TCDD_UNIT.TEXT_HVAC_2_TRAIN,
        (wagonIndex: number, data: any[], setColor, setText, setPosition, setTextAnchor) => {
          const textValue = data?.[TcddSubSystem.TEXT_SYSTEM]?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.[wagonIndex]?.[AirConditionSystemKeys.hvac2] ?? '-';
          setText(`${textValue} °C`);
          setColor(Color.White);

          const size = data?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.length ?? 0;
          const isLastWagon = wagonIndex === size - 1;

          setPosition(isLastWagon ? 'left' : 'right');
          setTextAnchor(isLastWagon ? 'end' : 'start');

          return true;
        },
        {
          fontSize: '16',
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: '700',
          offsetX: 5,
          offsetY: 0
        }
      ),
      createTextRule(
        TCDD_UNIT.TEXT_DRIVER_HVAC_WAGON,
        (wagonIndex: number, data: any[], setColor, setText) => {
          const textValue = data?.[TcddSubSystem.TEXT_SYSTEM]?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.[wagonIndex]?.[AirConditionSystemKeys.driverHvac] ?? '-';
          setText(`${textValue} °C`);
          setColor(Color.White);

          return true;
        },
        {
          fontSize: '16',
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: '700',
          offsetX: 10,
          offsetY: 0,
          position: 'right',
          textAnchor: 'start'
        }
      ),
      createTextRule(
        TCDD_UNIT.TEXT_HVAC_1_WAGON,
        (wagonIndex: number, data: any[], setColor, setText) => {
          const textValue = data?.[TcddSubSystem.TEXT_SYSTEM]?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.[wagonIndex]?.[AirConditionSystemKeys.hvac1] ?? '-';
          setText(`${textValue} °C`);
          setColor(Color.White);

          return true;
        },
        {
          fontSize: '16',
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: '700',
          offsetX: 10,
          offsetY: 0,
          position: 'right',
          textAnchor: 'start'
        }
      ),
      createTextRule(
        TCDD_UNIT.TEXT_HVAC_2_WAGON,
        (wagonIndex: number, data: any[], setColor, setText) => {
          const textValue = data?.[TcddSubSystem.TEXT_SYSTEM]?.[TcddSubSystem.AIR_CONDITION_SYSTEM]?.[wagonIndex]?.[AirConditionSystemKeys.hvac2] ?? '-';
          setText(`${textValue} °C`);
          setColor(Color.White);

          return true;
        },
        {
          fontSize: '16',
          fontFamily: 'Roboto',
          fontStyle: 'normal',
          fontWeight: '700',
          offsetX: 10,
          offsetY: 0,
          position: 'right',
          textAnchor: 'start'
        }
      )
    ];
  }
}
